import Logo from 'ppbl/components/Logo'
import FlagButton from 'ppbl/components/common/FooterSection/FlagButton'
import FooterLink from 'ppbl/components/common/FooterSection/FooterLink'
import { trackClick } from 'ppbl/utils/fpti-helper'
import PropTypes from 'prop-types'
import React from 'react'
import { generateProps } from './__utils__'
import './index.css'
import { BodyText } from '@paypalcorp/pp-react'

export default function FooterSection({ page }) {
  const {
    mainLinks,
    secondaryLinks,
    tertiaryLinks,
    footerDisclaimers,
    country,
    logo,
  } = generateProps(page)

  const renderMainLogo = (logoImage) => {
    if (logoImage) {
      const {
        text = 'PayPal',
        href = '/webapps/mpp/home',
        imageUrl,
      } = logoImage
      return (
        <Logo
          data-testid="footer-main-logo"
          text={text}
          href={href}
          url={imageUrl}
          className="pypl-logo-rebrand"
          data-pa-click="Footer-Logo-PayPal Logo"
        />
      )
    }
    return null
  }

  const renderFooterDisclaimers = (list) => {
    return list.map((elem) => (
      <li key={elem.id} id={elem.id} className="footer-disclaimer-text">
        {elem.superscript ? <BodyText>{elem.superscript}</BodyText> : null}
        {elem.value}
      </li>
    ))
  }

  const fptiClick = (e, text) => {
    const fptiData = {
      page,
      component: 'FooterSection',
      link: `FooterSection_${e.text ? e.text : text}_button`,
    }

    trackClick(fptiData)
  }

  const renderLinks = (links) => {
    const { list = [] } = links

    return list.map((elem) => (
      <li key={elem.id} id={elem.id} className="footer-copyright footer-li">
        <FooterLink
          href={elem.href}
          onClick={(e) => fptiClick(e, elem.text)}
          text={elem.text}
          className="footer-link"
        />
      </li>
    ))
  }

  const renderFlag = (flag) => {
    if (flag) {
      const { text, locale, href, imageUrl } = flag
      return (
        <FlagButton
          data-testid="footer-flag"
          text={text}
          locale={locale}
          href={href}
          imageUrl={imageUrl}
          className={`country lazy-load-flag ${locale}`}
          onClick={(e) => fptiClick(e, text)}
        />
      )
    }
    return null
  }

  const renderCountrySelector = (countryString) => {
    const { flag } = countryString || {}
    return (
      <ul className="footer-main">
        <li className="country-selector footer-li">{renderFlag(flag)}</li>
      </ul>
    )
  }

  return (
    <div className="footerContainer">
      <div id="footerSection">
        <footer
          data-building-block="organism"
          className="common-footer footer-grid"
          id="footer"
          translate="no"
        >
          <div className="container">
            <div className="pypl-logo-wrapper-footer">
              {renderMainLogo(logo)}
            </div>
            <div className="row">
              <div className="links-container">
                {mainLinks && (
                  <ul className="footer-main ul-main-links">
                    {renderLinks(mainLinks)}
                  </ul>
                )}

                {renderCountrySelector(country)}
              </div>
            </div>
            <div className="row">
              <div className="links-container">
                <hr className="hidden-lg-down primary" />
              </div>
            </div>

            <div className="row">
              <div className="links-container">
                {secondaryLinks && (
                  <ul className="footer-secondary copyright-section">
                    {renderLinks(secondaryLinks)}
                  </ul>
                )}
                <hr className="hidden-lg-down secondary" />
                {tertiaryLinks && (
                  <ul className="footer-tertiary copyright-section">
                    {renderLinks(tertiaryLinks)}
                  </ul>
                )}
              </div>

              <ul className="footer-disclaimers unordered-list">
                {renderFooterDisclaimers(footerDisclaimers)}
              </ul>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}

FooterSection.propTypes = {
  page: PropTypes.string,
}
